<template>
  <div>
    <CommonSection />
    <div class="container-fluid">
      <v-row>
        <v-col>
          <card shadow type="secondary">
            <div slot="header" class="bg-white border-0">
              <h3 class="mb-0 float-left card-header-name">
                Useful Links List
              </h3>
              <router-link
                :to="{ path: 'useful-links/create' }"
                class="float-right mt-0"
              >
                <v-tooltip
                  bottom
                  :color="$vuetify.theme.themes.light.tooltipColor"
                >
                  <template v-slot:activator="{ on: tooltip, attrs }">
                    <img
                      class="mr-2"
                      v-bind="attrs"
                      v-on="{ ...tooltip }"
                      src="@/assets/images/Plus.svg"
                    />
                  </template>
                  <span>Add Useful Links</span>
                </v-tooltip>
              </router-link>
            </div>
            <v-card>
              <v-card-title>
                <v-row>
                  <v-col>
                    <v-text-field
                      class="search-text-field"
                      v-model="search"
                      append-icon="search"
                      label="Search by Title"
                      single-line
                      hide-details
                      v-debounce:1s="searchFilter"
                      :debounce-events="['click', 'keydown']"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="usefulLinks"
                :loading="loading"
                loading-text="Loading... Please wait"
                :page.sync="page"
                :items-per-page="itemsPerPage"
                hide-default-footer
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <router-link :to="{ path: 'useful-links/' + item._id }">
                    <v-tooltip
                      bottom
                      :color="$vuetify.theme.themes.light.tooltipColor"
                    >
                      <template v-slot:activator="{ on: tooltip, attrs }">
                        <img
                          v-bind="attrs"
                          v-on="{ ...tooltip }"
                          class="mr-2 edit-icon"
                          src="@/assets/images/Edit.svg"
                        />
                      </template>
                      <span>Edit</span>
                    </v-tooltip>
                  </router-link>

                  <delete-component
                    :id="item._id"
                    module="link/delete"
                    @requestDeleted="requestDeleted"
                  ></delete-component>
                </template>
              </v-data-table>

              <v-card-actions class="justify-end pt-2">
                <v-pagination
                  circle
                  v-model="page"
                  :length="pageCount"
                ></v-pagination>
              </v-card-actions>
            </v-card>
          </card>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import CommonSection from "@/components/CommonHeader";
import DeleteComponent from "@/components/DeleteComponent";
import { usefullinkService } from "@/services";

export default {
  name: "Useful Links",
  components: {
    CommonSection,
    DeleteComponent,
  },
  data: () => ({
    page: 1,
    pageCount: 0,
    loading: true,
    itemsPerPage: 50,
    usefulLinks: [],
    search: null,
    status: true,
    headers: [
      {
        text: "Title",
        align: "start",
        value: "title",
      },
      { text: "Url", value: "url" },
      { text: "Actions", value: "actions", sortable: false },
    ],
  }),
  watch: {
    page() {
      this.initialize();
    },
  },
  created() {
    this.initialize();
  },
  methods: {
    async initialize() {
      this.loading = true;
      const params = {
        limit: parseInt(this.itemsPerPage),
        skip:
          parseInt(this.page) * parseInt(this.itemsPerPage) -
          parseInt(this.itemsPerPage),
        title: this.search,
      };
      const usefulLinks = await usefullinkService.list(params);
      if (usefulLinks.data.data.length > 0) {
        this.pageCount = Math.ceil(
          usefulLinks.data.option[0].count / this.itemsPerPage
        );
        this.usefulLinks = usefulLinks.data.data;
        this.loading = false;
      } else {
        if (this.page !== 1) {
          this.page--;
        }
        this.loading = false;
        this.usefulLinks = [];
      }
    },
    searchFilter() {
      this.page = 1;
      this.initialize();
    },
    statusFilter() {
      this.page = 1;
      this.initialize();
    },
    requestDeleted() {
      this.initialize();
    },
    getColor(object) {
      if (object.isActive) {
        return "#30E362";
      } else if (object.isDelete) {
        return "red";
      } else {
        return "#5B5B5B";
      }
    },
  },
};
</script>
